import { Attribute, ChangeDetectorRef, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { getFormErrorMessage } from '@app/core/utils/form-error-message.util';

@Component({
  standalone: true,
  selector: 'ups-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'form-group input-underline'
  },
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormInputComponent
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: FormInputComponent
    }
  ]
})
export class FormInputComponent implements ControlValueAccessor, Validator {

  @Input() public label?: string;
  @Input() public placeholder!: string;
  @Input() public required: boolean = false;
  @Input() public disabled: boolean = false;
  public isTouched: boolean = false;
  public value: any = '';
  public formControl!: AbstractControl;
  public errorMsg!: string;
  protected onChange: (_val: any) => void = (_val: any) => {};
  protected onTouched: () => void = () => {};

  constructor(
    @Attribute('type') public type: 'email' | 'hidden' | 'number' | 'search' | 'tel' | 'text' | 'url',
    @Attribute('autocomplete') public autocomplete:  'name' | 'email' | 'tel' | 'url' | 'on' | 'off' | 'honorific-prefix' | 'given-name' | 'additional-name' | 'family-name' | 'honorific-suffix' | 'nickname' | 'username' | 'one-time-code' | 'organization-title' | 'organization' | 'street-address' | 'address-line1' | 'address-line2' | 'address-line3' | 'address-level4' | 'address-level3' | 'address-level2' | 'address-level1' | 'country' | 'country-name' | 'postal-code' | 'cc-name' | 'cc-given-name' | 'cc-additional-name' | 'cc-family-name' | 'cc-number' | 'cc-exp' | 'cc-exp-month' | 'cc-exp-year' | 'cc-csc' | 'cc-type' | 'transaction-currency' | 'transaction-amount' | 'language' | 'bday' | 'bday-day' | 'bday-month' | 'bday-year' | 'sex' | 'tel-country-code' | 'tel-national' | 'tel-area-code' | 'tel-local' | 'tel-extension',
    protected readonly ch: ChangeDetectorRef
  ) { }

  public registerOnChange(fn: any): void{ this.onChange = fn; }
  
  public registerOnTouched(fn: any): void{ this.onTouched = fn; } 
  
  public writeValue(val: any): void{ 
    this.value = val; 
    this.ch.markForCheck();
  }
  
  public setDisabledState?(d: boolean): void{ 
    this.disabled = d; 
    this.ch.markForCheck();
  }

  public validate(control: AbstractControl): ValidationErrors | null{
    this.formControl = control;
    return null;
  }

  public input({ value }: any): void{
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }

    if (!this.disabled) {
      this.value = value;
      this.onChange(this.value);
      this.errorMsg = getFormErrorMessage(this.formControl.errors, this.label);
    }
  }
}
